import styled from "styled-components";

interface IContainer{
    displayContainer: boolean;
}

const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  >div.body{
      display: flex;
      width: 100%;
      flex-direction: column;
      padding: 0 0.75rem;
  }
  ${(props) => props.displayContainer ? `
    width: 49%;
    margin: 1rem 2px;
    border-radius: 6px;
    box-shadow: 0 0 5px rgb(0 0 0 / 20%);
    >div.title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.85rem;
        letter-spacing: .1em;
        text-transform: uppercase;
        padding: 0.5rem 0.75rem;
        color: var(--purple-lighter);
    }
    >div.body{
        padding: 0.5rem 0.75rem;
    }
    @media(max-width: 600px){
        width: 100%;
    }
   ` : ""}
  
`;

export default Container;
